import Image from "@tiptap/extension-image";
import Placeholder from "@tiptap/extension-placeholder";
import { BubbleMenu, EditorContent, FloatingMenu, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

import { getImageUrl, uploadPublicImg } from "@/lib/aws-amplify/host-storage";

import { TiptapBubbleMenu } from "./bubble-menu";
import { TiptapFloatingMenu } from "./floating-menu";
import { EventHandler } from "./plugins/ImageUpload2";
import { base64ToFile, resizeImage } from "./utils/editor-image";

import type { Content, Extensions } from "@tiptap/react";

type Props = {
	content: Content;
	hotelID: string;

	handleEditorContentChange: (editorContent: string) => void;
};

export const TiptapEditor = ({ content, hotelID, handleEditorContentChange }: Props) => {
	Image.options.inline = true;

	const uploadImage = async (file: File): Promise<string> => {
		const b64 = await resizeImage(file);
		const parsed = base64ToFile(b64, file.name);
		const res = await uploadPublicImg(`${hotelID}/imgs`, `pubimg.${new Date().getTime()}`, parsed);
		return getImageUrl(res);
	};

	const extensions = [
		StarterKit, //
		Image,
		Placeholder.configure({
			placeholder: `例）ここは ”最果ての旅のオアシス”。大阪の西、ベイエリアの玄関口に位置する...`,
			emptyEditorClass:
				"before:content-[attr(data-placeholder)] before:float-left before:text-zinc-400 before:h-0 before:pointer-events-none",
		}),
		EventHandler({ uploader: uploadImage }),
	] satisfies Extensions;

	const editor = useEditor({
		content,
		extensions,
		onUpdate({ editor }) {
			handleEditorContentChange(editor.getHTML());
		},
	});

	if (!editor) return null;

	return (
		<>
			<EditorContent editor={editor} />
			<FloatingMenu editor={editor}>
				<TiptapFloatingMenu editor={editor} uploadImage={uploadImage} />
			</FloatingMenu>
			<BubbleMenu editor={editor}>
				<TiptapBubbleMenu editor={editor} uploadImage={uploadImage} />
			</BubbleMenu>
		</>
	);
};
